import React, { useState } from "react";
import Select from "react-select";
import InformationToolTip from "../Utility/Helpers/InformationToolTip";
import { ReactComponent as SearchIcon } from "bootstrap-icons/icons/search.svg";

import { Parser } from "html-to-react";
import DatePicker from "react-datepicker";

function MoreFiltersView({
  tabType,
  fundingCategoryOptions,
  handleFundingCategory,
  fundingCategorySelected,
  issuingOrgSelected,
  handleIssuingOrgs,
  activityCode,
  activityCodesSelected,
  fundingOrgs,
  handleFundingOrgs,
  fundingOrganizations,
  clinicalTrialOptions,
  clinicalTrialsSelected,
  clinicalTrialsAllowedSelected,
  handleActivityCode,
  handleClinicalTrials,
  handleInstrument,
  fundingInstrumentSelected,
  fundingInstrumentOptions,
  handleCareerStage,
  careerStageSelected,
  handleFundingOpportunityType,
  fundingOpportunitySelected,
  handlePDPI,
  pdpiSelected,
  handleMentored,
  mentoredSelected,
  handleReferenceLetters,
  refLetterSelected,
  noticeTypeOptions,
  handleNoticeType,
  noticeType,
  handleAppType,
  appTypesSelected,
  handleQueryChange,
  subcategory_rtcd,
  handleFundingSubCategory_RTCD,
  fundingSubCategory_RTCD,
  fundingSubRTCDShow,
  subcategory_rd,
  handleFundingSubCategory_RD,
  fundingSubCategory_RD,
  fundingSubRDShow,
  subcategory_sb,
  handleFundingSubCategory_SB,
  fundingSubCategory_SB,
  fundingSubSBShow,
  query,
  InformationToolTipOptions,
  career_stage,
  appTypesAllowed,
  fundingOpportunityType,
  activeFOA,
  expiredFOA,
  activeNotices,
  expiredNotices,
  handleTypeChange,
  titleSelected,
  handleTitleSearch,
  CustomMultiValue,
  nosisCheckbox,
  isSmallScreen,
  startDate,
  endDate,
  onStartChange,
  onEndChange,
  handlePredefinedRange,
  researchInitiative,
  researchInitiativeSelected,
  handleResearchInitiative
}) {
  const [isCalendarOpenStart, setIsCalendarOpenStart] = useState(false);
  const [isCalendarOpenEnd, setIsCalendarOpenEnd] = useState(false);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      paddingLeft: state.data.isTabbed ? "30px" : "10px",
    }),
  };

  const calendarButton = (type) => {
    setIsCalendarOpenStart(false);
    setIsCalendarOpenEnd(false);
    handlePredefinedRange(type);
  };

  const CustomHeader = ({ date, decreaseMonth, increaseMonth }) => {
    return (
      <div>
        <button className="datepicker-caret" onClick={decreaseMonth}>
          {"<"}
        </button>
        <span>
          {date.toLocaleString("default", { month: "long" })}{" "}
          {date.getFullYear()}
        </span>
        <button className="datepicker-caret" onClick={increaseMonth}>
          {">"}
        </button>
        <div className="datepicker-header-container">
          <button
            className="datepicker-header"
            onClick={() => calendarButton("today")}
          >
            Today
          </button>
          <button
            className="datepicker-header"
            onClick={() => calendarButton("thisWeek")}
          >
            This week
          </button>
          <button
            className="datepicker-header"
            onClick={() => calendarButton("thisMonth")}
          >
            This month
          </button>
          <button
            className="datepicker-header"
            onClick={() => calendarButton("lastMonth")}
          >
            Last month
          </button>
          <button
            className="datepicker-header"
            onClick={() => calendarButton("thisYear")}
          >
            This Year
          </button>
          <button
            className="datepicker-header"
            onClick={() => calendarButton("lastYear")}
          >
            Last Year
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="row d-flex justify-content-between">
      <div className="col-md-3">
        {tabType === "foa" && (
          <>
            <div className="mb-3">
              <label role="button" className="form-check me-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="activeFOA"
                  value="active,activenosis"
                  checked={activeFOA}
                  onChange={handleTypeChange}
                />
                <span className="form-check-label">Active Opportunities</span>
              </label>
              <label role="button" className="form-check me-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="expiredFOA"
                  value="expired,expirednosis"
                  checked={expiredFOA}
                  onChange={handleTypeChange}
                />
                <span className="form-check-label">Expired Opportunities</span>
              </label>
              <label role="button" className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="nosisCheck"
                  checked={nosisCheckbox}
                  onChange={handleTypeChange}
                />
                <span className="form-check-label">
                  Include Notices of Special Interest (NOSIs)
                </span>
              </label>
            </div>

            <div className="category-wrapper">
              <div className="mb-2">
                <div className="fw-bold mb-3 fs-5">
                  Funding Category
                  <InformationToolTip
                    content={InformationToolTipOptions.fundingCategory}
                    placement={isSmallScreen ? "bottom" : "right"}
                  />
                </div>

                <Select
                  options={fundingCategoryOptions}
                  isMulti
                  onChange={handleFundingCategory}
                  hideSelectedOptions={false}
                  value={fundingCategorySelected}
                />
              </div>

              {fundingSubRTCDShow && (
                <>
                  <div className="fw-bold mb-2 mt-3">
                    Research Training and Career Development Filters
                  </div>
                  <div className="mb-3">
                    <div className="fw-bold mb-2">
                      Program Type
                      <InformationToolTip
                        content={InformationToolTipOptions.rtcd}
                        placement={isSmallScreen ? "bottom" : "right"}
                      />
                    </div>
                    <Select
                      options={subcategory_rtcd}
                      isMulti
                      onChange={handleFundingSubCategory_RTCD}
                      hideSelectedOptions={false}
                      value={fundingSubCategory_RTCD}
                    />
                  </div>

                  <div className="mb-3">
                    <div className="fw-bold mb-3">
                      Career Stage
                      <InformationToolTip
                        content={InformationToolTipOptions.careerStage}
                        placement={isSmallScreen ? "bottom" : "right"}
                      />
                    </div>
                    <Select
                      options={career_stage}
                      isMulti
                      onChange={handleCareerStage}
                      hideSelectedOptions={false}
                      value={careerStageSelected}
                    />
                  </div>

                  <div className="mb-3">
                    <div className="fw-bold">
                      PD/PI Citizenship Requirements
                      <InformationToolTip
                        content={InformationToolTipOptions.pdpi}
                        placement={isSmallScreen ? "bottom" : "right"}
                      />
                    </div>
                    <label role="button" className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        value="Y"
                        name="pdpi"
                        onChange={handlePDPI}
                        checked={pdpiSelected === "Y"}
                      />
                      <span className="form-check-label">Yes</span>
                    </label>
                    <label role="button" className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        value="N"
                        name="pdpi"
                        onChange={handlePDPI}
                        checked={pdpiSelected === "N"}
                      />
                      <span className="form-check-label">No</span>
                    </label>
                  </div>

                  <div className="mb-3">
                    <div className="fw-bold">
                      Mentored
                      <InformationToolTip
                        content={InformationToolTipOptions.mentored}
                        placement={isSmallScreen ? "bottom" : "right"}
                      />
                    </div>
                    <label role="button" className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        value="Y"
                        name="mentored"
                        onChange={handleMentored}
                        checked={mentoredSelected === "Y"}
                      />
                      <span className="form-check-label">Yes</span>
                    </label>
                    <label role="button" className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        value="N"
                        name="mentored"
                        onChange={handleMentored}
                        checked={mentoredSelected === "N"}
                      />
                      <span className="form-check-label">No</span>
                    </label>
                  </div>

                  <div className="mb-2">
                    <div className="fw-bold">
                      Reference Letters
                      <InformationToolTip
                        content={InformationToolTipOptions.referenceLetters}
                        placement={isSmallScreen ? "bottom" : "right"}
                      />
                    </div>
                    <label role="button" className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        value="Y"
                        name="reference"
                        onChange={handleReferenceLetters}
                        checked={refLetterSelected === "Y"}
                      />
                      <span className="form-check-label">Yes</span>
                    </label>
                    <label role="button" className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        value="N"
                        name="reference"
                        onChange={handleReferenceLetters}
                        checked={refLetterSelected === "N"}
                      />
                      <span className="form-check-label">No</span>
                    </label>
                  </div>
                </>
              )}

              {fundingSubRTCDShow && fundingSubRDShow && <hr />}

              {fundingSubRDShow && (
                <>
                  <div className="fw-bold mb-2">
                    Research and Development Filters
                  </div>
                  <div className="mb-3">
                    <div className="fw-bold mb-3">
                      Program Type
                      <InformationToolTip
                        content={InformationToolTipOptions.rd}
                        placement={isSmallScreen ? "bottom" : "right"}
                      />
                    </div>
                    <Select
                      options={subcategory_rd}
                      isMulti
                      onChange={handleFundingSubCategory_RD}
                      hideSelectedOptions={false}
                      value={fundingSubCategory_RD}
                    />
                  </div>
                </>
              )}

              {fundingSubRTCDShow && fundingSubSBShow && <hr />}

              {fundingSubSBShow && (
                <>
                  <div className="fw-bold mb-2">Small Business Filters</div>
                  <div className="mb-2">
                    <div className="fw-bold mb-3">
                      Program Type
                      <InformationToolTip
                        content={InformationToolTipOptions.sb}
                        placement={isSmallScreen ? "bottom" : "right"}
                      />
                    </div>
                    <Select
                      options={subcategory_sb}
                      isMulti
                      onChange={handleFundingSubCategory_SB}
                      hideSelectedOptions={false}
                      value={fundingSubCategory_SB}
                    />
                  </div>
                </>
              )}
            </div>
          </>
        )}

        {tabType === "notices" && (
          <div>
            <div className="mb-3">
              <label role="button" className="form-check me-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="activeNotices"
                  value="notices,activenosis"
                  checked={activeNotices}
                  onChange={handleTypeChange}
                />
                <span className="form-check-label">Active Notices</span>
              </label>
              <label role="button" className="form-check me-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="expiredNotices"
                  value="expirednosis"
                  checked={expiredNotices}
                  onChange={handleTypeChange}
                />
                <span className="form-check-label">Expired Notices</span>
              </label>
              <label role="button" className="form-check me-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="nosisCheck"
                  checked={nosisCheckbox}
                  onChange={handleTypeChange}
                />
                <span className="form-check-label">
                  Include Notices of Special Interest (NOSIs)
                </span>
              </label>
            </div>
            <div className="mb-4">
              <div className="fw-bold mb-3 fs-5">
                Notice Type
                <InformationToolTip
                  content={InformationToolTipOptions.noticeType}
                  placement={isSmallScreen ? "bottom" : "right"}
                  trigger="click"
                />
              </div>

              <Select
                options={noticeTypeOptions}
                isMulti
                onChange={handleNoticeType}
                hideSelectedOptions={false}
                value={noticeType}
                className="option-select"
                classNamePrefix="react-select"
              />
            </div>
          </div>
        )}

        <div className="mb-5">
          <div className="fw-bold mb-3 fs-5">
            Release Date Range
            <InformationToolTip
              content={InformationToolTipOptions.releaseDateRange}
              placement={isSmallScreen ? "bottom" : "right"}
            />
          </div>

          <>
            <div className="d-flex align-items-center">
              <DatePicker
                selected={startDate}
                onChange={onStartChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                dateFormat="MM/dd/yyyy"
                placeholderText="Start Date"
                renderCustomHeader={CustomHeader}
                className="me-2"
                popperPlacement="bottom-start"
                open={isCalendarOpenStart}
                onInputClick={() => setIsCalendarOpenStart(true)}
                onClickOutside={() => setIsCalendarOpenStart(false)}
              />
              <span> – </span>
              <DatePicker
                selected={endDate}
                onChange={onEndChange}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                dateFormat="MM/dd/yyyy"
                placeholderText="End Date"
                renderCustomHeader={CustomHeader}
                className="ms-2"
                open={isCalendarOpenEnd}
                onInputClick={() => setIsCalendarOpenEnd(true)}
                onClickOutside={() => setIsCalendarOpenEnd(false)}
              />
            </div>
          </>
        </div>
      </div>
      <div className="col-md-3">
        <div className="mb-5">
          <div className="fw-bold mb-3 fs-5">
            Funding Organization(s)
            <InformationToolTip
              content={InformationToolTipOptions.fundingOrgs}
              placement={isSmallScreen ? "bottom" : "bottom"}
            />
          </div>
          <Select
            options={fundingOrgs}
            isMulti
            styles={customStyles}
            onChange={handleFundingOrgs}
            hideSelectedOptions={false}
            value={fundingOrganizations}
            formatOptionLabel={(option) => (
              <div>{Parser().parse(option.label)}</div>
            )}
            components={{ MultiValue: CustomMultiValue }}
            className="option-select"
            classNamePrefix="react-select"
          />
          <label role="button" className="form-check mb-3 mt-2">
            <input
              className="form-check-input"
              type="checkbox"
              value=""
              checked={issuingOrgSelected}
              onChange={handleIssuingOrgs}
            />
            <span className="form-check-label">Issuing Organization Only</span>
          </label>
        </div>

        {tabType === "foa" && (
          <>
            <div className="mb-5">
              <div className="fw-bold mb-3 fs-5">
                Application Types Allowed
                <InformationToolTip
                  content={InformationToolTipOptions.appTypesAllowed}
                  placement={isSmallScreen ? "bottom" : "bottom"}
                />
              </div>
              <Select
                options={appTypesAllowed}
                isMulti
                onChange={handleAppType}
                hideSelectedOptions={false}
                value={appTypesSelected}
              />
            </div>
          </>
        )}

        {tabType === "foa" && (
          <div className="mb-5">
            <div className="fw-bold mb-3 fs-5">
              Funding Opportunity Type
              <InformationToolTip
                content={InformationToolTipOptions.fundingOpportunityType}
                placement={isSmallScreen ? "bottom" : "bottom"}
              />
            </div>
            <Select
              options={fundingOpportunityType}
              isMulti
              onChange={handleFundingOpportunityType}
              value={fundingOpportunitySelected}
              hideSelectedOptions={false}
            />
          </div>
        )}

        {tabType === "notices" && (
          <>
            <div className="mb-5">
              <div className="fw-bold mb-3 fs-5">
                Research Initiatives
                {/* <InformationToolTip
                  content={InformationToolTipOptions.appTypesAllowed}
                  placement={isSmallScreen ? "bottom" : "bottom"}
                /> */}
              </div>
              <Select
                options={researchInitiative}
                isMulti
                onChange={handleResearchInitiative}
                hideSelectedOptions={false}
                value={researchInitiativeSelected}
                className="option-select"
                classNamePrefix="react-select"
              />
            </div>
          </>
        )}
      </div>
      <div className="col-md-4">
        <div className="mb-4">
          <div className="fw-bold mb-3 fs-5">
            Keyword
            <InformationToolTip
              content={InformationToolTipOptions.keyword}
              placement={isSmallScreen ? "bottom" : "left"}
            />
          </div>

          <label className="form-label d-block">
            <div className="searchIcon">
              <SearchIcon />
            </div>
            <input
              type="text"
              className="form-control mt-2 border-1"
              id="searchQuery"
              placeholder="Quick Search"
              onChange={handleQueryChange}
              value={query}
            />
          </label>

          <label role="button" className="form-check pb-4">
            <input
              className="form-check-input"
              type="checkbox"
              value=""
              checked={titleSelected}
              onChange={handleTitleSearch}
            />
            <span className="form-check-label">Title Only</span>
          </label>
        </div>

        {tabType === "foa" && (
          <>
            <div className="mb-5">
              <div className="fw-bold mb-3 fs-5">
                Activity Code
                <InformationToolTip
                  content={InformationToolTipOptions.activityCodes}
                  placement={isSmallScreen ? "bottom" : "left"}
                />
              </div>
              <Select
                options={activityCode}
                isMulti
                onChange={handleActivityCode}
                hideSelectedOptions={false}
                value={activityCodesSelected}
              />
            </div>

            <div className="mb-5">
              <div className="fw-bold mb-3 fs-5">
                Clinical Trials
                <InformationToolTip
                  content={InformationToolTipOptions.clinicalTrials}
                  placement={isSmallScreen ? "bottom" : "left"}
                />
              </div>
              <label role="button" className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  value="allowed"
                  name="clinical_trials_allowed"
                  checked={clinicalTrialsAllowedSelected === "allowed"}
                  onChange={handleClinicalTrials}
                />
                <span className="form-check-label">
                  Clinical Trials Allowed
                </span>
              </label>
              <label role="button" className="form-check ms-4">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value="optional"
                  name="clinical_trial_allowed_options"
                  disabled={!clinicalTrialOptions}
                  onChange={handleClinicalTrials}
                  checked={clinicalTrialsSelected.includes("Optional")}
                />
                <span className="form-check-label">Optional</span>
              </label>
              <label role="button" className="form-check ms-4">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value="required"
                  name="clinical_trial_allowed_options"
                  disabled={!clinicalTrialOptions}
                  onChange={handleClinicalTrials}
                  checked={clinicalTrialsSelected.includes(
                    "Required,Required_Infrastructure"
                  )}
                />
                <span className="form-check-label">Required</span>
              </label>
              <label role="button" className="form-check ms-4">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value="besh"
                  name="clinical_trial_allowed_options"
                  disabled={!clinicalTrialOptions}
                  onChange={handleClinicalTrials}
                  checked={clinicalTrialsSelected.includes("Basic_Trial")}
                />
                <span className="form-check-label">
                  Basic Experimental Studies with Humans (BESH) Required
                </span>
              </label>
              <label role="button" className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  value="not_allowed"
                  name="clinical_trials_allowed"
                  onChange={handleClinicalTrials}
                  checked={clinicalTrialsAllowedSelected === "not_allowed"}
                />
                <span className="form-check-label">
                  Clinical Trials Not Allowed
                </span>
              </label>
            </div>

            <div className="mb-5">
              <div className="fw-bold mb-3 fs-5">
                Funding Instrument
                <InformationToolTip
                  content={InformationToolTipOptions.fundingInstrument}
                  placement={isSmallScreen ? "bottom" : "left"}
                />
              </div>
              <Select
                options={fundingInstrumentOptions}
                isMulti
                onChange={handleInstrument}
                hideSelectedOptions={false}
                value={fundingInstrumentSelected}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default MoreFiltersView;
